<template>
  <el-dropdown class="lang-container hover-pointer" trigger="click">
    <span
      >{{ language }} <i class="el-icon-caret-bottom el-icon--right" />
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="changeLangauge('zh')">
        <span style="display: block">简体中文</span>
      </el-dropdown-item>
      <el-dropdown-item @click.native="changeLangauge('en')">
        <span style="display: block">English</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  data() {
    return {
      language: "",
    };
  },
  created() {
    const currentLang = this.$ls.get("lang") || "zh";
    const queryLang = this.$route.query.lang;
    if (queryLang && /^(zh|en)$/.test(queryLang) && currentLang !== queryLang) {
      this.changeLangauge(queryLang);
    } else {
      this.showLangauge();
    }
  },
  methods: {
    showLangauge() {
      const currentLang = this.$ls.get("lang") || "zh";
      switch (currentLang) {
        case "zh":
          this.language = "简体中文";
          document.title = "密尔克卫-用户中心";
          break;
        case "en":
          this.language = "English";
          document.title = "Milkyway - User Center";
      }
      this.$ls.set("lang", currentLang);
    },
    changeLangauge(lang) {
      this.$i18n.locale = lang;
      this.$ls.set("lang", lang);
      this.$ls.set("isChangeLang", true);
      if (window.location.search) {
        window.location.href =
          window.location.origin + window.location.pathname;
      } else {
        window.location.reload();
      }
    },
  },
};
</script>
<style lang="scss">
.hover-pointer {
  span {
    cursor: pointer;
  }
}
</style>
